import { render, staticRenderFns } from "./DetectedFaultsTable.vue?vue&type=template&id=2ed70b7a"
import script from "./DetectedFaultsTable.vue?vue&type=script&lang=js"
export * from "./DetectedFaultsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports